<template>
  <div v-if="visible" class="note-search-bar">
    <div class="search-input-container">
      <i class="fa fa-search" />
      <input
        ref="searchInput"
        v-model="searchQuery"
        type="text"
        class="search-input"
        :placeholder="$t.get('Search in note...')"
        :aria-label="$t.get('Search in note')"
        @input="onSearchInput"
        @keydown="handleKeydown"
      />
      <div class="search-controls">
        <span v-if="totalMatches > 0" class="match-count">
          {{ currentMatch }}/{{ totalMatches }}
        </span>
        <button
          class="btn-nav"
          :disabled="totalMatches === 0"
          :title="$t.get('Previous match')"
          :aria-label="$t.get('Previous match')"
          @click="goToPrevious"
        >
          <i class="fa fa-chevron-up" aria-hidden="true" />
        </button>
        <button
          class="btn-nav"
          :disabled="totalMatches === 0"
          :title="$t.get('Next match')"
          :aria-label="$t.get('Next match')"
          @click="goToNext"
        >
          <i class="fa fa-chevron-down" aria-hidden="true" />
        </button>
        <button
          class="btn-close"
          :title="$t.get('Close search')"
          :aria-label="$t.get('Close search')"
          @click="closeSearch"
        >
          <i class="fa fa-times" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteSearchBar',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    currentMatch: {
      type: Number,
      default: 0,
    },
    totalMatches: {
      type: Number,
      default: 0,
    },
  },
  emits: ['update:modelValue', 'next', 'previous', 'close'],
  data() {
    return {
      searchQuery: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.searchQuery = newVal;
    },
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
          this.$refs.searchInput?.select();
        });
      }
    },
  },
  methods: {
    onSearchInput() {
      this.$emit('update:modelValue', this.searchQuery);
    },
    handleKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.goToNext();
      } else if (event.key === 'Enter' && event.shiftKey) {
        event.preventDefault();
        this.goToPrevious();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.closeSearch();
      }
    },
    goToNext() {
      this.$emit('next');
    },
    goToPrevious() {
      this.$emit('previous');
    },
    closeSearch() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.note-search-bar {
  position: relative;
  background: $col-white;
  border-bottom: 1px solid $col-border;
  z-index: 100;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input-container i.fa-search {
  color: $col-button;
  margin-left: 4px;
}

.search-input {
  flex: 1;
  border: 1px solid $col-border;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: $col-button;
  }
}

.search-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.match-count {
  font-size: 12px;
  color: #666;
  margin-right: 4px;
  min-width: 40px;
  text-align: center;
}

.btn-nav,
.btn-close {
  background-image: none !important;
  background-color: $col-button;
  border: 1px solid $col-button-border;
  color: $col-white;
  border-radius: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;

  &:hover:not(:disabled) {
    background-color: $col-button-hover;
    border-color: $col-button-border-hover;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.btn-close {
  margin-left: 4px;
}

</style>

